
import { of as observableOf, Observable, Subject, takeUntil } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Conta } from './conta.model';
import { AbConta } from 'app/abstract/full-pages/conta/conta.abstract';

@Injectable({
  providedIn: 'root'
})
export class ContaService extends AbConta implements OnDestroy {
  KEY_MULTICONTA = "multiconta";

  private readonly destroy$ = new Subject();
  constructor(http: HttpClient) {
    super(http);
  }

  public getConta() {
    return this.get('contas/all/');
  }

  public saveConta(conta: Conta): Observable<any> {
    return this.save("contas/", conta);
  }

  public salvarTipoConta(conta: Conta): Observable<any> {
    return this.save(`contas/salvartipoconta`, conta);
  }

  public getTipoContaLogada() {
    return this.get('contas/tipocontalogada');
  }

  public eMulticonta() {
    let multiconta: boolean = JSON.parse(sessionStorage.getItem(this.KEY_MULTICONTA));
    if (multiconta) {
      return observableOf(multiconta);
    }
    let ret = this.get('contas/multiconta');
    this.salvarEMultiContaNoStorage(ret);
    return ret;
  }

  public salvarEMultiContaNoStorage(mlt: Observable<any>) {
    mlt.pipe(takeUntil(this.destroy$)).subscribe(multiconta => {
      sessionStorage.setItem(this.KEY_MULTICONTA, JSON.stringify(multiconta));
    });
  }

  public cleanToken() {
    if (sessionStorage.getItem(this.KEY_MULTICONTA))
      sessionStorage.removeItem(this.KEY_MULTICONTA);
  }

  public getMultiContaStorage(): boolean {
    let mc: boolean = JSON.parse(sessionStorage.getItem(this.KEY_MULTICONTA));
    if (!mc)
      return false;
    return mc;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
